import React, { Fragment } from 'react';
import { translate } from '../../Services/translation';
import SpecificationDetailsRow from './SpecificationDetailsRow';
import SpecificationDetailsBlasting from './SpecificationDetailsBlasting';

const SpecificationDetails = ({ item, loading, inactive, showDeleteBtn = true }) => {
  const { isCoilItem, coilDetails, cuttingDetails, blastingDetails } = item.cartSelections;

  let specificationList = isCoilItem ? coilDetails : cuttingDetails,
    showBlastingDetails = (!specificationList || specificationList.length == 0) && blastingDetails;
  return (
    <Fragment>
      {showBlastingDetails && <SpecificationDetailsBlasting blastingDetails={blastingDetails} loading={loading} />}

      {!showBlastingDetails && <table className={'specification-table' + (inactive ? ' specification-table--inactive' : '')}>
        <thead>
          <tr>
            <th>{translate('checkout.cart.specification.specification')}</th>
            <th>{translate('checkout.cart.specification.quantity')}</th>
            <th>{translate('checkout.cart.specification.priceunit')}</th>
            <th>{translate('checkout.cart.specification.weight')}</th>
            <th className='specification-table__right-align-cell'>
              {translate('checkout.cart.specification.price')}
            </th>
            {<th>{/* Delete button */}</th>}
          </tr>
        </thead>
        <tbody>
          {specificationList.map((specification, index) => (
            <Fragment key={'cart-spec-' + index}>
              <SpecificationDetailsRow item={item} specification={specification} loading={loading} showDeleteBtn={specificationList.length > 1 && showDeleteBtn} />
            </Fragment>
          ))}
        </tbody>
      </table>}
    </Fragment>);
};

export default SpecificationDetails;
